import React, { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";

function DonationbillPrintThermal({
  name,
  mobile,
  address,
  amount,
  amount_in_words,
  receiver,
  receiptno,
  date,
  AfterPrintClose,
  festival_type,
}) {
  const logo = require("../assets/images/logo.jpg");
  const printTriggerBtn = useRef();
  const printComponentRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      printTriggerBtn.current.click();
    }, 0);
  }, []);

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <button className="d-none" ref={printTriggerBtn}>
            Print
          </button>
        )}
        content={() => printComponentRef.current}
        onAfterPrint={() => {
          AfterPrintClose();
        }}
        pageStyle="@page { margin: 0; } @media print { body { -webkit-print-color-adjust: exact; margin: 0; padding: 0; } }"
      />
      <div className="d-none">
        {/* Render for print only */}
        <div
          ref={printComponentRef}
          style={{
            width: '100%',
            maxWidth: '78mm',
            margin: '0 auto',
            padding: '2mm',
            boxSizing: 'border-box',
            fontFamily: 'monospace, sans-serif',
            color: '#000',
            fontSize: '14px',
            lineHeight: '1.4'
          }}
        >
          {/* Header */}
          <div className="text-center mb-2">
            <h5 className="mb-0 fw-bold">உ</h5>
            <img
              src={logo}
              alt="logo"
              style={{ width: '50px', height: '50px', margin: '5px 0' }}
            />
            <div style={{ fontSize: '12px', fontWeight: 'bold' }}>
              ஸ்ரீ மஹா கணபதி அனுக்ரஹம் <br/>
              ஸ்ரீ சிவகாமியம்மன் சமேத <br/> ஸ்ரீ ஆலடீஸ்வரன் துணை
            </div>
            <h4 className="fw-bold mt-1 mb-0" style={{ fontSize: '15px' }}>
              ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
            </h4>
            <div style={{ fontSize: '12px' }}>
              ஈஞ்சார், சிவகாசி மேற்கு, விருதுநகர் மாவட்டம் - 626124
            </div>
          </div>

          <div className="text-center fw-bold mb-2 pb-1 border-bottom border-dark" style={{ fontSize: '16px' }}>
            {festival_type === 'Kumbaabishegam' ? `கும்பாபிஷேகம் ${new Date().getFullYear()} நன்கொடை ரசீது` : `நன்கொடை ரசீது ${new Date().getFullYear()}`}
          </div>

          {/* Details */}
          <div className="d-flex justify-content-between mb-2 fw-bold" style={{ fontSize: '13px' }}>
            <span>ரசீது எண்: {receiptno}</span>
            <span>தேதி: {date}</span>
          </div>

          <div className="mb-1">
            <span className="fw-bold">பெயர்:</span> {name}
          </div>
          <div className="mb-1">
            <span className="fw-bold">செல்:</span> {mobile}
          </div>
          <div className="mb-2 pb-2 border-bottom border-dark">
            <span className="fw-bold">முகவரி:</span> {address}
          </div>

          <div className="mb-2">
            <div className="fw-bold text-center" style={{ fontSize: '20px' }}>
              ₹ {amount}
            </div>
            <div className="text-center mt-1" style={{ fontSize: '12px', wordWrap: 'break-word' }}>
              ({amount_in_words})
            </div>
          </div>

          <div className="border-top border-dark pt-2 text-center" style={{ fontSize: '12px' }}>
            <div className="fw-bold">வசூலிப்பவர்: {receiver}</div>
            <div>தொடர்புக்கு: 9994604513</div>
          </div>
          
          {/* Space for tearing */}
          <div style={{ height: '10mm' }}></div>
        </div>
      </div>
    </>
  );
}

export default DonationbillPrintThermal;
